/* Newsletter popup - open at 50% scroll depth, whichever comes first.
   Additive to assets/theme.js, which still opens the popup on its own
   timer (the section's "Show after (seconds)" setting). This file only
   ever opens the popup earlier; it never changes the dismissal rules.
   Remove the <script> tag in layout/theme.liquid to revert. */
(function () {
  'use strict';

  var popup = document.querySelector('[data-popup]');
  if (!popup) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.location.search.indexOf('customer_posted') !== -1) return;

  var THRESHOLD = 0.5;
  var KEY = 'esco-popup-dismissed';

  function recentlyDismissed() {
    try {
      var at = localStorage.getItem(KEY);
      if (!at) return false;
      var days = parseInt(popup.dataset.days, 10) || 3;
      return Date.now() - parseInt(at, 10) <= days * 86400000;
    } catch (e) {
      return false;
    }
  }

  function scrolledFraction() {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return 0;
    return (window.scrollY || doc.scrollTop) / scrollable;
  }

  function onScroll() {
    if (scrolledFraction() < THRESHOLD) return;
    window.removeEventListener('scroll', onScroll);
    if (popup.dataset.test !== 'true' && recentlyDismissed()) return;
    popup.classList.add('is-open');
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();
